// Module
var code = `<div [ngClass]="{ 'is-invalid': invalidObj.managementIdError }" class="Field HOA-flextable-component__cell-ids">
    <div class="HOA-flex-center-info-button">
        <label class="Field-label HOA-flex-center-info-button" tid="managementIdLabel" for="managementId">
            Management ID
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <button type="button" class="u-mL4 u-pB2 u-posRelative HOA-flex-center-info-button"
                (click)="managementIdHelper()" tid="managementIdHelper">
    <span class="Icon Icon--24 icon-utility-basics-question_circle-24 u-iconBlue background-image-none">
<svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 72 72"><title>Management ID</title><path
        class="stroke_layer" d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z" fill="none" stroke="#838383"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="3.8"></path><path class="fill_layer"
                                                                                       d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                                                       fill="#838383"
                                                                                       stroke-width="3.8"></path><path
        class="stroke_layer" data-name="stroke_layer"
        d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
        fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.8"></path></svg>
</span>
        </button>
    </div>
    <input type="text" app-allow-pattern allowPattern="\\d" class="Input" id="managementId" tid="managementId"
           name="managementId" [(ngModel)]="property.hoa.pmc.couponId"
           (change)="blurFunction.emit();managementId();" [disabled]="disableInputsProperty" required
           maxlength="4" aria-invalid="invalidObj.managementIdError"
           attr.aria-describedby="{{invalidObj.managementIdError && 'managementId-error' || undefined }}"
           spellcheck="false">
    <span class="Field-error" id="managementId-error"
          tid="managementIdError">{{managementNameError ? 'Invalid Management ID' : 'Please enter your Management ID'}}</span>
    <span class="Field-detail" [hidden]="!managementName || invalidObj.managementIdError"
          tid="managementIdName">{{managementName}}</span>

</div>
<div [ngClass]="{ 'is-invalid': invalidObj.associationIdError }"
     class="Field HOA-flextable-component__cell-ids">
    <div class="HOA-flex-center-info-button">
        <label class="Field-label HOA-flex-center-info-button" tid="associationIdLabel" for="associationId">
            Association ID
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <button type="button" class="u-mL4 u-pB2 u-posRelative HOA-flex-center-info-button"
                (click)="associationIdHelper()" tid="associationIdHelper">
<span class="Icon Icon--24 icon-utility-basics-question_circle-24 u-iconBlue background-image-none">
<svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 72 72"><title>Association ID</title><path
        class="stroke_layer" d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z" fill="none" stroke="#838383"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="3.8"></path><path class="fill_layer"
                                                                                       d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                                                       fill="#838383"
                                                                                       stroke-width="3.8"></path><path
        class="stroke_layer" data-name="stroke_layer"
        d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
        fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.8"></path></svg>
</span>
        </button>
    </div>
    <input type="text" app-allow-pattern allowPattern="\\d|[a-zA-Z]" class="Input" id="associationId"
           tid="associationId" name="associationId" [(ngModel)]="property.hoa.couponId"
           (change)="blurFunction.emit();associationId();" [disabled]="disableInputsProperty" required
           maxlength="6" aria-invalid="invalidObj.associationIdError"
           attr.aria-describedby="{{invalidObj.associationIdError && 'associationId-error' || undefined }}"
           spellcheck="false">
    <span class="Field-error" id="associationId-error"
          tid="associationIdError">{{hoaNameError ? 'Invalid Association ID' : 'Please enter your Association ID' }}</span>
    <span class="Field-detail" [hidden]="!hoaName || invalidObj.associationIdError"
          tid="associationIdName">{{hoaName}}</span>
</div>
<div [ngClass]="{ 'is-invalid': invalidObj.propertyIdError }" class="Field HOA-flextable-component__cell-ids ">
    <div class="HOA-flex-center-info-button">
        <label class="Field-label HOA-flex-center-info-button" tid="propertyIdLabel" for="propertyId">
            Property / Account Number
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <button type="button" class="u-mL4 u-pB2 u-posRelative HOA-flex-center-info-button"
                (click)="propertyIdHelper()" tid="propertyIdHelper">
<span class="Icon Icon--24 icon-utility-basics-question_circle-24 u-iconBlue background-image-none">
<svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 72 72"><title>Property / Account Number</title><path
        class="stroke_layer" d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z" fill="none" stroke="#838383"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="3.8"></path><path class="fill_layer"
                                                                                       d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                                                       fill="#838383"
                                                                                       stroke-width="3.8"></path><path
        class="stroke_layer" data-name="stroke_layer"
        d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
        fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.8"></path></svg>
</span>
        </button>
    </div>
    <input type="text" class="Input" id="propertyId" tid="propertyId" name="propertyId"
           [(ngModel)]="property.couponId" (change)="blurFunction.emit();propertyId();"
           [disabled]="disablePropertyId" required maxlength="16" aria-invalid="invalidObj.propertyIdError"
           attr.aria-describedby="{{invalidObj.propertyIdError && 'propertyId-error' || undefined }}"
           spellcheck="false">
    <span class="Field-error" id="propertyId-error" tid="propertyIdError">Please enter your Property ID</span>
</div>`;
// Exports
module.exports = code;